<xemex-card [title]="'installations.general.ownership' | translate" [fill]="true">
  <div class="flex flex-col gap-4">
    <xemex-detail-field [label]="'installations.general.owningPartner' | translate">
      @if (installation().partnerOid) {
        <a
          class="ownership__partner"
          data-testid="owning-partner"
          [routerLink]="['/', APP_PATHS.Partners, installation().partnerOid]"
        >
          <mat-icon fontSet="material-icons-outlined" aria-hidden="true">apartment</mat-icon>
          <span>{{ installation().partnerName ?? installation().partnerOid }}</span>
        </a>
      }
    </xemex-detail-field>

    @if (canViewGroups()) {
      <div class="ownership__divider"></div>

      <xemex-detail-field
        [label]="'installations.general.installationGroups' | translate"
        [loading]="groupsLoading()"
      >
        @if (groups().length) {
          <ul class="m-0 flex list-none flex-wrap gap-2 p-0" data-testid="installation-groups">
            @for (group of groups(); track group.installationGroupOid) {
              <li>
                <a
                  class="ownership__chip rounded-md"
                  [routerLink]="['/', APP_PATHS.InstallationGroups, group.installationGroupOid]"
                >
                  <mat-icon fontSet="material-icons-outlined" aria-hidden="true"
                    >workspaces</mat-icon
                  >
                  <span>{{ group.name }}</span>
                </a>
              </li>
            }
          </ul>
        } @else {
          <span class="text-text-secondary">{{
            'installations.general.noGroups' | translate
          }}</span>
        }
        @if (groupsPartial()) {
          <p class="m-0 mt-2 text-sm text-text-secondary" data-testid="installation-groups-partial">
            {{ 'installations.general.groupsPartial' | translate }}
          </p>
        }
      </xemex-detail-field>
    }
  </div>
</xemex-card>
